import { shallowEqual } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const useAuth = () => {
  const {
    isAuthorized,
    userId,
    userTeams,
    hasTeam,
    isAdmin,
    isModerator,
    isGroupAdmin,
  } = useSelector(
    ({ auth }: RootState) => ({
      isAuthorized: auth.user != null,
      userId: auth.user?.id,
      userTeams: auth.user?.userTeams,
      hasTeam: auth.user?.userTeams?.length !== 0,
      isAdmin: auth.user?.roles?.length
        ? auth.user.roles.some((a) => a.value === "SYSTEM_ADMIN")
        : false,
      isGroupAdmin: auth.user?.roles?.length
        ? auth.user.roles.some((a) => a.value === "GROUP_ADMIN")
        : false,
      isModerator: auth.user?.roles?.length
        ? auth.user.roles.some((a) => a.value === "MODERATOR")
        : false,
    }),
    shallowEqual
  );

  const history = useHistory();

  useEffect(() => {
    if (isAuthorized && !hasTeam) {
      history.push("/onBoarding");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthorized, hasTeam]);

  return {
    isAuthorized,
    userId,
    userTeams,
    hasTeam,
    isAdmin,
    isModerator,
    isGroupAdmin,
  };
};
